/**
 * @fileoverview InstructionRenderer component for the Storyteller web application.
 * Renders instructions based on the provided text.
 *
 * @example
 * // Basic usage
 * <InstructionRenderer text="Instructions text" />
 */

import { LabelProps, rankWith, uiTypeIs } from '@jsonforms/core'
import { withJsonFormsLabelProps } from '@jsonforms/react'
import { VanillaRendererProps, withVanillaControlProps } from '@jsonforms/vanilla-renderers'
import { useTranslation } from 'react-i18next'
import { Instructions } from '../../sections/Instructions'

/**
 * @function InstructionRenderer
 * @description Component for rendering instructions.
 * @param {LabelProps & VanillaRendererProps} props - The props for the InstructionRenderer component.
 * @returns {JSX.Element} The InstructionRenderer component.
 */
function InstructionRenderer(props: LabelProps & VanillaRendererProps) {
    const { text } = props
    const { t } = useTranslation()
    return <Instructions instructions={t(text)} />
}

export const InstructionTester = rankWith(3, uiTypeIs('Instructions'))

export default withVanillaControlProps(withJsonFormsLabelProps(InstructionRenderer))
